import { reactive } from "vue";

import { useFileDownload } from "./useFileDownload";

import type { FileAttachment } from "shared";

// Состояние инлайн-медиа (objectURL + прогресс) на уровне модуля, ключ — URL
// вложения. virtua пересоздаёт компоненты сообщений при скролле: держи мы это в
// инстансе, каждый ремонт сбрасывал бы прогресс и отзывал objectURL — видео
// «вечно прогружалось» бы заново. Память ограничена кэшем блобов в
// useFileDownload (objectURL — лишь ссылка на тот же Blob).
// Превью в ленте — из FileAttachment.poster (генерирует отправитель),
// локально ничего не генерируем.
export interface MediaSourceState {
    url: string | null;
    progress: number;
    loading: boolean;
    error: boolean;
}

const states = new Map<string, MediaSourceState>();

export function useMediaSource() {
    const { fetchBlob } = useFileDownload();

    function get(att: FileAttachment): MediaSourceState {
        let state = states.get(att.url);
        if (!state) {
            state = reactive({
                url: null,
                progress: 0,
                loading: false,
                error: false,
            });
            states.set(att.url, state);
        }
        return state;
    }

    // Однократная загрузка+расшифровка: параллельные вызовы (несколько ремонтов
    // одного сообщения) сливаются через флаг loading + кэш промисов в fetchBlob.
    async function load(att: FileAttachment): Promise<void> {
        const state = get(att);
        if (state.url || state.loading) {
            return;
        }
        state.loading = true;
        state.error = false;
        try {
            const blob = await fetchBlob(att, (fraction) => {
                state.progress = fraction;
            });
            state.url = URL.createObjectURL(blob);
        } catch {
            state.error = true;
        } finally {
            state.loading = false;
        }
    }

    return { get, load };
}
